import { useMemo } from 'react'

import { supportsGuardianMessaging } from '@lyrahealth-inc/shared-app-logic/src/features/programConfigs/programHelpers'

import { useGuardianForSelectedClient } from '../../../../hooks/useGuardianForSelectedClient'
import { useCurrentEpisodeForClient } from '../../../episodes/data/hooks/useCurrentEpisodeForClient'
import { MessengerParticipant } from '../types'

// Which sendable participant threads apply to the selected client. AI threads are appended from
// existing conversations by useMessengerThreads because they are always read-only.
export const useEligibleParticipants = (): MessengerParticipant[] => {
  const { currentEpisode } = useCurrentEpisodeForClient()
  const { hasGuardian, isGuardianForMinor } = useGuardianForSelectedClient()

  return useMemo(() => {
    const result = [MessengerParticipant.PATIENT]
    // Child (DA Engage minor): the patient thread is relabeled as the caregiver thread elsewhere.
    if (!isGuardianForMinor && hasGuardian && supportsGuardianMessaging(currentEpisode?.program_name)) {
      result.push(MessengerParticipant.GUARDIAN)
    }
    return result
  }, [currentEpisode?.program_name, hasGuardian, isGuardianForMinor])
}
